import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withKeys as _withKeys, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "main-tab-header" }
const _hoisted_3 = { class: "summary-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "kpi-card-row mb-15" }
const _hoisted_11 = { class: "kpi-card" }
const _hoisted_12 = { class: "kpi-value text-primary" }
const _hoisted_13 = { class: "kpi-card" }
const _hoisted_14 = { class: "kpi-value" }
const _hoisted_15 = { class: "kpi-card" }
const _hoisted_16 = { class: "kpi-value" }
const _hoisted_17 = { class: "kpi-card" }
const _hoisted_18 = { class: "kpi-value" }
const _hoisted_19 = { class: "kpi-card" }
const _hoisted_20 = { class: "kpi-value" }
const _hoisted_21 = { class: "kpi-card highlight-green" }
const _hoisted_22 = { class: "kpi-value text-green" }
const _hoisted_23 = { class: "kpi-card highlight-blue" }
const _hoisted_24 = { class: "kpi-value text-blue" }
const _hoisted_25 = { class: "summary-table-wrapper" }
const _hoisted_26 = { style: {"font-weight":"600"} }
const _hoisted_27 = { style: {"color":"#67c23a","font-weight":"bold"} }
const _hoisted_28 = { style: {"color":"#409eff","font-weight":"bold"} }
const _hoisted_29 = { class: "detail-container" }
const _hoisted_30 = { class: "filter-container" }
const _hoisted_31 = { class: "filter-box" }
const _hoisted_32 = { class: "filter-box" }
const _hoisted_33 = { class: "filter-box" }
const _hoisted_34 = { class: "filter-box" }
const _hoisted_35 = { class: "filter-box" }
const _hoisted_36 = { class: "filter-box" }
const _hoisted_37 = { class: "filter-box" }
const _hoisted_38 = { class: "filter-box" }
const _hoisted_39 = { class: "filter-box" }
const _hoisted_40 = { class: "filter-box" }
const _hoisted_41 = { class: "filter-box" }
const _hoisted_42 = { class: "filter-box" }
const _hoisted_43 = { class: "filter-box" }
const _hoisted_44 = { class: "filter-box" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_47 = { class: "tab-title_left fl" }
const _hoisted_48 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_grid_item = _resolveComponent("grid-item")!
  const _component_grid_layout = _resolveComponent("grid-layout")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.mainActiveTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mainActiveTab) = $event)),
          type: "card",
          onTabChange: _ctx.handleMainTabChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "人员提成汇总",
              name: "summary"
            }),
            _createVNode(_component_el_tab_pane, {
              label: "收款业务明细",
              name: "detail"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onTabChange"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.listQuery.startTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
              type: "date",
              placeholder: " ",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              onChange: _ctx.handleFilter,
              size: _ctx.t('table.btnSize')
            }, null, 8, ["modelValue", "onChange", "size"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.listQuery.endTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
              type: "date",
              placeholder: " ",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              onChange: _ctx.handleFilter,
              size: _ctx.t('table.btnSize')
            }, null, 8, ["modelValue", "onChange", "size"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "人员信息", -1)),
            _createVNode(_component_el_select, {
              filterable: true,
              modelValue: _ctx.listQuery.personnelId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.personnelId) = $event)),
              class: "filter-item",
              placeholder: "全部人员(销售/工程师)",
              clearable: "",
              size: _ctx.t('table.btnSize'),
              onFocus: _ctx.handlePersonnelFocus,
              onChange: _ctx.handleFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personnelOption, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.mark,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "size", "onFocus", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "所属公司", -1)),
            _createVNode(_component_el_select, {
              filterable: true,
              modelValue: _ctx.listQuery.titleId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.titleId) = $event)),
              class: "filter-item",
              placeholder: "",
              clearable: "",
              size: _ctx.t('table.btnSize'),
              onFocus: _ctx.handleFilterTitleFocus,
              onChange: _ctx.handleFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTitleCompanyOptions(), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "size", "onFocus", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              type: "primary",
              size: _ctx.t('table.btnSize'),
              onClick: _ctx.handleFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.search')), 1)
              ]),
              _: 1
            }, 8, ["size", "onClick"])), [
              [_directive_waves]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              size: _ctx.t('table.btnSize'),
              onClick: _ctx.handleReset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.reset')), 1)
              ]),
              _: 1
            }, 8, ["size", "onClick"])), [
              [_directive_waves]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              type: "success",
              size: _ctx.t('table.btnSize'),
              onClick: _ctx.handleExportSummary
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode(" 导出汇总 ", -1)
              ]))]),
              _: 1
            }, 8, ["size", "onClick"])), [
              [_directive_waves]
            ]),
            _createElementVNode("span", {
              class: "svg-icon cursor mr-10 ml-10",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getSummaryList && _ctx.getSummaryList(...args)))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "kpi-title" }, "涉及人员数", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.kpiStats.totalPersons) + " ", 1),
              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "kpi-unit" }, "人", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "kpi-title" }, "关联业务单数", -1)),
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.kpiStats.totalCount) + " ", 1),
              _cache[37] || (_cache[37] = _createElementVNode("span", { class: "kpi-unit" }, "单", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "kpi-title" }, "累计已收款总额", -1)),
            _createElementVNode("div", _hoisted_16, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.kpiStats.totalReceivedFee)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "kpi-title" }, "累计已开票总额", -1)),
            _createElementVNode("div", _hoisted_18, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.kpiStats.totalInvoicePrice)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "kpi-title" }, "累计税后总成本", -1)),
            _createElementVNode("div", _hoisted_20, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.kpiStats.totalCost)), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "kpi-title" }, "累计已收款提成", -1)),
            _createElementVNode("div", _hoisted_22, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.kpiStats.totalReceivedCommission)), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "kpi-title" }, "累计已开票提成", -1)),
            _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString(_ctx.formatMoney(_ctx.kpiStats.totalInvoiceCommission)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.summaryList,
            border: "",
            stripe: "",
            style: {"width":"100%"},
            "show-summary": "",
            "summary-method": _ctx.getSummaryRow,
            "header-cell-style": { background: '#f5f7fa', color: '#606266' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "userName",
                label: "人员姓名",
                "min-width": "110",
                fixed: "left"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(row.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "deptName",
                label: "所属部门",
                "min-width": "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "role",
                label: "岗位角色",
                "min-width": "120",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tag, {
                    type: row.role.includes('销售') && row.role.includes('工程师') ? 'danger' : row.role.includes('销售') ? 'primary' : 'success',
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.role), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessCount",
                label: "业务单数",
                "min-width": "90",
                align: "center",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalReceivedFee",
                label: "已收款总额",
                "min-width": "130",
                align: "right",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalReceivedFee)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalInvoicePrice",
                label: "已开票总额",
                "min-width": "130",
                align: "right",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalInvoicePrice)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalPartsCostWithoutTax",
                label: "税后出库成本",
                "min-width": "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalPartsCostWithoutTax)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalOutsourceCostWithoutTax",
                label: "税后外包成本",
                "min-width": "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalOutsourceCostWithoutTax)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalMarketCost",
                label: "市场成本",
                "min-width": "110",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalMarketCost)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalCostWithoutTax",
                label: "税后总成本",
                "min-width": "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(" ¥" + _toDisplayString(_ctx.formatMoney(row.totalCostWithoutTax)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "receivedCommission",
                label: "已收款提成",
                "min-width": "130",
                align: "right",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_27, "¥" + _toDisplayString(_ctx.formatMoney(row.receivedCommission)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "invoiceCommission",
                label: "已开票提成",
                "min-width": "130",
                align: "right",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_28, "¥" + _toDisplayString(_ctx.formatMoney(row.invoiceCommission)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "110",
                align: "center",
                fixed: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    link: "",
                    size: "small",
                    onClick: ($event: any) => (_ctx.handleViewPersonnelDetail(row))
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode(" 查看明细 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "summary-method"])), [
            [_directive_loading, _ctx.summaryLoading]
          ])
        ])
      ], 512), [
        [_vShow, _ctx.mainActiveTab === 'summary']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          (!_ctx.isFilterCollapse)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "客户名称", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.customerCompanyName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.customerCompanyName) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.no,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[47] || (_cache[47] = _createElementVNode("span", { class: "label" }, "业务品牌", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.brand,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.brand) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[48] || (_cache[48] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.name,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.name) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[49] || (_cache[49] = _createElementVNode("span", { class: "label" }, "型号", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.model,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.model) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[50] || (_cache[50] = _createElementVNode("span", { class: "label" }, "人员信息", -1)),
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.listQuery.personnelId,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.personnelId) = $event)),
                    class: "filter-item",
                    placeholder: "全部人员(销售/工程师)",
                    clearable: "",
                    size: _ctx.t('table.btnSize'),
                    onFocus: _ctx.handlePersonnelFocus,
                    onChange: _ctx.handleFilter
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personnelOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "size", "onFocus", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[51] || (_cache[51] = _createElementVNode("span", { class: "label" }, "订单号码", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.customerOrderNo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.listQuery.customerOrderNo) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[52] || (_cache[52] = _createElementVNode("span", { class: "label" }, "发票号码", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listQuery.invoiceNo,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listQuery.invoiceNo) = $event)),
                    style: {"width":"200px"},
                    size: _ctx.t('table.btnSize'),
                    class: "filter-item",
                    clearable: "",
                    onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                  }, null, 8, ["modelValue", "size", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[53] || (_cache[53] = _createElementVNode("span", { class: "label" }, "开票状态", -1)),
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.listQuery.invoiceStatus,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.listQuery.invoiceStatus) = $event)),
                    class: "filter-item",
                    placeholder: "",
                    onChange: _ctx.handleFilter,
                    clearable: "",
                    size: _ctx.t('table.btnSize')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "size"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[54] || (_cache[54] = _createElementVNode("span", { class: "label" }, "税率", -1)),
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.listQuery.rate,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.listQuery.rate) = $event)),
                    class: "filter-item",
                    placeholder: "",
                    onChange: _ctx.handleFilter,
                    clearable: "",
                    size: _ctx.t('table.btnSize')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rateOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "size"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _cache[55] || (_cache[55] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.listQuery.startTime,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                    type: "date",
                    placeholder: " ",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    onChange: _ctx.handleFilter,
                    size: _ctx.t('table.btnSize')
                  }, null, 8, ["modelValue", "onChange", "size"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[56] || (_cache[56] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.listQuery.endTime,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                    type: "date",
                    placeholder: " ",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    onChange: _ctx.handleFilter,
                    size: _ctx.t('table.btnSize')
                  }, null, 8, ["modelValue", "onChange", "size"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[57] || (_cache[57] = _createElementVNode("span", { class: "label" }, "所属公司", -1)),
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.listQuery.titleId,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.listQuery.titleId) = $event)),
                    class: "filter-item",
                    placeholder: "",
                    clearable: "",
                    size: _ctx.t('table.btnSize'),
                    onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleFilterTitleFocus())),
                    onChange: _ctx.handleFilter
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTitleCompanyOptions(), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "size", "onChange"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              type: "primary",
              size: _ctx.t('table.btnSize'),
              onClick: _ctx.handleFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.search')), 1)
              ]),
              _: 1
            }, 8, ["size", "onClick"])), [
              [_directive_waves]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              type: "primary",
              size: _ctx.t('table.btnSize'),
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleCommand('add')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.add')), 1)
              ]),
              _: 1
            }, 8, ["size"])), [
              [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              type: "primary",
              size: _ctx.t('table.btnSize'),
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleCommand('batch-fee')))
            }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                _createTextVNode(" 批量收款 ", -1)
              ]))]),
              _: 1
            }, 8, ["size"])), [
              [_directive_permission, { pkey: `${_ctx.permissionName}_BATCH_RECEIVE` }]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              size: _ctx.t('table.btnSize'),
              onClick: _ctx.handleReset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.reset')), 1)
              ]),
              _: 1
            }, 8, ["size", "onClick"])), [
              [_directive_waves]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              class: "filter-item",
              size: _ctx.t('table.btnSize'),
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
              ]),
              _: 1
            }, 8, ["size"])), [
              [_directive_waves]
            ]),
            _createElementVNode("span", {
              class: "svg-icon cursor mr-10 ml-10",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleCommand('refresh')))
            }, [...(_cache[59] || (_cache[59] = [
              _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
            ]))]),
            _createElementVNode("span", {
              class: "svg-icon cursor",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleCommand('column')))
            }, [...(_cache[60] || (_cache[60] = [
              _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
            ]))])
          ])
        ]),
        _createVNode(_component_grid_layout, {
          layout: _ctx.layouts,
          "onUpdate:layout": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.layouts) = $event)),
          "col-num": 12,
          "row-height": _ctx.rowHeight,
          "is-draggable": false,
          "is-resizable": true,
          "is-mirrored": false,
          "vertical-compact": true,
          margin: [10, 10],
          "use-css-transforms": false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layouts, (item, index) => {
              return (_openBlock(), _createBlock(_component_grid_item, {
                x: item.x,
                y: item.y,
                w: item.w,
                h: item.h,
                i: item.i,
                key: item.i,
                minW: item.minW,
                maxW: item.maxW,
                minH: item.minH,
                static: item.static,
                onResize: _ctx.handleResizedEvent,
                onResized: _ctx.handleResizedEvent
              }, {
                default: _withCtx(() => [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives((_openBlock(), _createBlock(_component_TableList, {
                          ref_for: true,
                          ref: rf => { if (rf) _ctx.tableDataRef[index] = rf },
                          dataList: _ctx.list,
                          columnAllData: _ctx.columnAllData,
                          tableName: _ctx.TableName,
                          permissionName: _ctx.permissionName,
                          showSelection: true,
                          isShowPagination: false,
                          handleDefaultWidth: 80,
                          highlightCurrentRow: true,
                          layoutHeight: true,
                          newHpx: _ctx.newHpx,
                          showSummary: true,
                          style: {"height":"100%","overflow":"hidden"},
                          onRowClick: _ctx.handleRowClick,
                          onCommandChange: _ctx.handleCommand
                        }, {
                          "operation-action": _withCtx((scope) => [
                            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                              href: "javascript:void(0);",
                              class: "mr-10",
                              type: "primary",
                              onClick: ($event: any) => (_ctx.handleCommand('fee', scope.row))
                            }, {
                              default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                _createTextVNode(" 收款 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])), [
                              [_directive_permission, { pkey: `${_ctx.permissionName}_FEE` }]
                            ])
                          ]),
                          _: 1
                        }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "onRowClick", "onCommandChange"])), [
                          [_directive_loading, _ctx.listLoading]
                        ]),
                        _withDirectives(_createVNode(_component_el_pagination, {
                          class: "mt-20",
                          total: _ctx.total,
                          currentPage: _ctx.listQuery.page,
                          "onUpdate:currentPage": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.listQuery.page) = $event)),
                          "page-size": _ctx.listQuery.size,
                          "page-sizes": _ctx.pageSizes,
                          onSizeChange: _ctx.handleSizeChange,
                          onCurrentChange: _ctx.handleCurrentChange,
                          layout: "total, sizes, prev, pager, next"
                        }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
                          [_vShow, _ctx.total > 0]
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (index === 1)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("ul", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.id,
                                class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                                onClick: ($event: any) => (_ctx.handleTabClick(item))
                              }, _toDisplayString(item.name), 11, _hoisted_48))
                            }), 128))
                          ])
                        ])
                      ], 512)), [
                        [_vShow, !_ctx.isSubMenuCollapse]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["x", "y", "w", "h", "i", "minW", "maxW", "minH", "static", "onResize", "onResized"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["layout", "row-height"])
      ], 512), [
        [_vShow, _ctx.mainActiveTab === 'detail']
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'business',
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[27] || (_cache[27] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleSubmit()))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "commandState"]))
      : _createCommentVNode("", true)
  ]))
}